import * as z from "zod";
import { mutator } from "./mutator";

export const deleteSSOProvider = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    provider: { kind: "ssoProvider", from: "id" },
  },
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, args: { provider } }) => {
    await tx.mutate.ssoProvider.delete({ id: provider.id });
  },
});
